import authAxios from "../common/authAxios";

class IdCardService {
  async getIdCardByUserId(userId, preview) {
    return await authAxios.get(
      `/id-card/get-by-user-id?userId=${userId}&preview=${preview}`,
      {
        responseType: "blob",
      }
    );
  }

  async getIdCardsByUserIds(userIds) {
    const userIdsString = Array.from(userIds).join(",");
    return await authAxios.get(
      `/id-card/get-by-user-ids?userIds=${userIdsString}`,
      {
        responseType: "blob",
      }
    );
  }

  async getUsersIdCardInfo({ keyword, status, page }) {
    return await authAxios.get(
      `/id-card/get-accepted-users?status=${status}&keyword=${keyword}&page=${page}`
    );
  }

  async createCustomCard(formData) {
    return await authAxios.post("/id-card/custom", formData, {
      responseType: "blob",
    });
  }
}

export default IdCardService;
